import { render, staticRenderFns } from "./StrandForm.vue?vue&type=template&id=2317d2fa&"
import script from "./StrandForm.vue?vue&type=script&lang=js&"
export * from "./StrandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports